import lodash from 'lodash'

import { TNotificationTrigger } from '../../../../../1stlog-ui/src/constants/notificationTriggers'
import { TOrderEntryNotificationOptions } from '../../types'
import { TNotificationOption } from './types'

export function mergeNotificationOptions(
  options: TNotificationOption[],
): TOrderEntryNotificationOptions {
  const fixedOptions = {}
  lodash.forEach(options, ({ type, trigger }) => {
    const current: any = lodash.get(fixedOptions, trigger)

    const types = type === 'emailAndSMS' ? ['email', 'sms'] : [type]
    if (current) {
      lodash.set(
        fixedOptions,
        [trigger, 'types'],
        lodash.uniq(lodash.concat(current.types, types)),
      )
    } else {
      lodash.set(fixedOptions, trigger, { trigger, types })
    }
  })
  return fixedOptions
}
